export var ZeroEtlJobType;
(function (ZeroEtlJobType) {
    ZeroEtlJobType["ZERO_ETL_JOB_TYPE_RDS_ZERO_ETL_SYNC"] = "RDS_ZERO_ETL_SYNC";
    ZeroEtlJobType["ZERO_ETL_JOB_TYPE_MONGODB_ZERO_ETL_SYNC"] = "MONGODB_ZERO_ETL_SYNC";
})(ZeroEtlJobType || (ZeroEtlJobType = {}));
